import API from 'src/util/api'
import useSWR, {mutate} from 'swr'

import { useToken } from './useToken'

const fetcher = url => API.get(url)

export function useUser() {
  const { token } = useToken()
  const { data, error } = useSWR(token ? 'me' : null, fetcher, {
    revalidateOnFocus: false,
    revalidateIfStale: true,
  })

  return {
    user: data,
    isAdmin: data?.role === 'ADMIN',
    isLoading: !error && !data && token,
    error,
    mutateUser: () => mutate('me'),
  }
}
